export default __webpack_public_path__ + "static/media/queue.70fac070.svg";